import dayjs from 'dayjs'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import weekDay from 'dayjs/plugin/weekday'
import customParse from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/pt-br'
import accounting from 'accounting'
import Http from './Http'
dayjs.locale('pt-br');
dayjs.extend(weekOfYear);
dayjs.extend(weekDay);
dayjs.extend(customParse);

const brazilAreaCodes = [11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99];
const DefaultRegExps = {
    email: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
};

const COLOR_RANGE = {
    '255,0,0': null,
    '0,255,0': null,
    '0,0,255': null,
    '0,128,128': null,
    '128,255,255': null,
    '128,128,255': null,
    '128,0,255': null,
    '255,128,64': null,
    '102,178,255': null,
    '204,0,102': null,
    '204,229,255': null,
    '255,204,153': null
};

const randomRGB = diff => {
    const c = Math.floor(Math.random()*256) + ',' + Math.floor(Math.random()*256) + ',' +Math.floor(Math.random()*256);
    if(diff && ((Object.prototype.toString.call(diff) === "[object String]" && c === diff) || (Object.prototype.toString.call(diff) === "[object Array]" && diff[c] === undefined))) {
        return randomRGB(diff);
    }
    return c;
};

const fillRandomRGB = (arr, size) => {
    if(arr.length >= size) return false;
    const str = arr.join("|");

    for(let i = arr.length; i < size; i++) {
        const color = randomRGB();
        if(str.indexOf(color) > -1) fillRandomRGB(arr, size);
        else arr.push(color);
    }
    return true;
};

const isString = val => typeof val === 'string' || val instanceof String;
const isNumber = v => typeof v === 'number';
const isArray = val => Array.isArray(val);
const isRegExp = val => val instanceof RegExp;
const isFunc = val => val && (typeof val === "function" || {}.toString.call(val) === '[object Function]');
const isProdEnv = () => process.env.NODE_ENV === 'production';
const isDevEnv = () => process.env.NODE_ENV === 'development';

const isSafari = () => /constructor/i.test(window.HTMLElement) || (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
})(!window['safari'] || (typeof safari !== 'undefined' && window.safari.pushNotification));

const isOpera = () => (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
const isFirefox = () => typeof InstallTrigger !== 'undefined';
const isIe = () => /(MSIE|Trident\/)+/gi.test(window.navigator.userAgent);
const isEdge = () => !this.isIe() && !!window.StyleMedia;;
const isChrome = () => !!window.chrome && !!window.chrome.webstore;
const isPushManager = () => 'PushManager' in window;
const isServiceWorker = () => 'serviceWorker' in navigator;
const isIntersectionObserver = () => 'IntersectionObserver' in window;
const isVibrate = () => 'vibrate' in navigator;
const isAndroid = () => !!navigator.userAgent.match(/Android/i);
const isIOS = () => !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
const isWindows = () => !!navigator.userAgent.match(/IEMobile/i) || !!navigator.userAgent.match(/WPDesktop/i);
const isMobile = () => isAndroid() || isIOS() || isWindows();
const isDesktop = () => !isMobile();
const isIndexedDB = () => 'indexedDB' in window;
const canShareLinks = 'share' in navigator;
const canShare = files => canShareLinks && 'canShare' in navigator && navigator.canShare(files);

const isCpf = (value) => {
    const s = String(value || '').replace(/\D/g, '');
    if (s.length !== 11) return false;

    if (/^(\d)\1{10}$/.test(s)) return false;

    const calc = (digits) => {
        let sum = 0;
        for (let i = 0; i < digits.length; i++) {
            sum += parseInt(digits.charAt(i), 10) * (digits.length + 1 - i);
        }
        const rev = 11 - (sum % 11);
        return rev > 9 ? 0 : rev;
    };

    const digit1 = calc(s.slice(0, 9));
    const digit2 = calc(s.slice(0, 9) + String(digit1));

    return digit1 === parseInt(s.charAt(9), 10) && digit2 === parseInt(s.charAt(10), 10);
}

function makeRandomId(length = 10) {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

const reqAnimationFrame = (function () {
    return window.requestAnimationFrame || function (callback) {
        window.setTimeout(callback, 1000 / 60);
    };
})();

function calcPage(page = 1, perPage = 20) {
    if (page <= 1) return [0, perPage - 1];
    return [(page - 1) * perPage, perPage - 1]
}

const validateEmail = email => DefaultRegExps.email.test(email);
const isEmpty = value => {
    return value === null || value === undefined || (isString(value) && value.trim() === '');
};

const replaceTags = str => {
    if (!isEmpty(str)) return str.replace(/[$<>]/g, group => {
        switch (group) {
            case '&':
                return '&amp;';
            case '<':
                return '&lt;';
            case '>':
                return '&gt;';
            default:
                return group
        }
    })
};

const vibrate = (pattern = 200) => {
    if (isVibrate()) navigator.vibrate(pattern);
};

const humanizeNumber = (num, digits = 0) => {
    const si = [
        { value: 1, symbol: "" },
        { value: 1E3, symbol: "k" },
        { value: 1E6, symbol: "M" },
        { value: 1E9, symbol: "G" },
        { value: 1E12, symbol: "T" },
        { value: 1E15, symbol: "P" },
        { value: 1E18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) break;
    }
    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
};

function pSBC(p,c0,c1,l){
    let r, g, b, P, f, t, h, i = parseInt, m = Math.round, a = typeof (c1) == "string";
    if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] !== 'r' && c0[0] !== '#') || (c1 && !a)) return null;
    if (!this.pSBCr) this.pSBCr = d => {
        let n = d.length, x = {};
        if (n > 9) {
            [r, g, b, a] = d = d.split(","), n = d.length;
            if (n < 3 || n > 4) return null;
            x.r = i(r[3] === "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
        } else {
            if (n === 8 || n === 6 || n < 4) return null;
            if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n === 9 || n === 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
            else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
        }
        return x
    };
    h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 === "c" ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 !== "c" ? this.pSBCr(c1) : P ? {
        r: 0,
        g: 0,
        b: 0,
        a: -1
    } : {r: 255, g: 255, b: 255, a: -1}, p = P ? p * -1 : p, P = 1 - p;
    if (!f || !t) return null;
    if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
    else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
    a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
    if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
    else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
}

const regStartBrazilCodes = new RegExp(`^(${brazilAreaCodes.join('|')})`, 'i');

function formatPhone(number = '') {
    const clear = ''.concat(number).replace(/\D+/gi, '');

    switch (clear.length) {
        case 7:
            return clear.replace(/(\d{3})(\d{4})/gi, '$1-$2');
        case 8:
        case 9:
        case 10:
        case 11:

            const is = regStartBrazilCodes.test(clear);
            if (is) {
                if (clear.length === 11) return clear.replace(/(\d{2})(\d)(\d{4})(\d{4})/gi, '($1) $2 $3-$4');

                return clear.replace(/(\d{2})(\d{3,4})(\d{4})/gi, '($1) $2-$3');
            }

            return clear.replace(/(\d{4})(\d{4})/gi, '$1-$2');
        default:
            return number;
    }
}

function formatDocument(document = '') {
    let clear = ''.concat(document).replace(/\D+/gi, '');
    switch (clear.length) {
        case 10:
            clear = `0${clear}`;
        case 11:
            return clear.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/gi, '$1.$2.$3-$4');
        case 13:
            clear = `0${clear}`;
        case 14:
            return clear.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/gi, '$1.$2.$3/$4-$5');
        default:
            return document
    }
}

function formatPostalCode(postal_code = '') {
    let clear = ''.concat(postal_code).replace(/\D+/gi, '');

    return clear.length === 8 ? clear.replace(/(\d{5})(\d{3})/gi, '$1-$2') : postal_code
}

function formatDate(value, format = 'DD/MM/YYYY') {
    if (!value) return '';

    return dayjs(value).format(format);
}

function formatMoney(value, symbol, precision, thousand, decimal, format) {
    if (!isNumber(value) && !value) return '';
    return format ? accounting.format(value.toString(), symbol, precision, thousand, decimal, format) : accounting.formatMoney(value.toString(), '', 2, '.', ',');
}

function formatNumber(value, precision = 2, decimal = ',', thousand = '.') {
    if (!value) return '';
    return accounting.formatNumber(value.toString(), precision, thousand, decimal);
}


function moneyToFloat(value) {
    if (isNumber(value) || !isString(value)) return value;
    try {
        return parseFloat(value.replace(/\./g, '').replace(/,/g, '.'))
    } catch (e) {
        console.error('Float conversion error', e);
        return 0;
    }
}

function highlightText(str = '', regex, tag = 'b') {
    if (!str || !regex) return str;

    return str.replace(regex, str => {
        return ['<', tag, '>', str, "</", tag, '>'].join('')
    });
}

function downloadPdf(url, fileName = 'Arquivo.pdf') {
    return downloadFile(url, 'application/pdf', fileName);
}

function downloadCsv(url, fileName = 'Arquivo.csv') {
    return downloadFile(url, 'text/csv', fileName);
}

function downloadFile(url, type, fileName = 'Arquivo') {
    return new Promise((resolve, reject) => {
        Http.get(url, {responseType: 'arraybuffer', timeout: 60000})
            .then(({data}) => {
                const blob = new Blob([data], {type: type});
                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = d;
                link.download=fileName;
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                setTimeout(() => document.body.removeChild(link), 5000);
                resolve(blob);
            })
            .catch(reject);
    })
}

function object2Params(obj = {}) {
    const param = {};

    Object.keys(obj).forEach(k => {
        if (obj[k]) param[k] = obj[k];
    });

    return new URLSearchParams(param);
}

/**
 * Remove acentos e converte para minúsculas uma string.
 * @param {string} texto O texto original.
 * @returns {string} O texto normalizado, sem acentos e em minúsculas.
 */
function normalizeText(texto) {
    if (!texto) return ''; // Retorna string vazia se o texto for nulo ou indefinido
    return texto
        .toLowerCase() // 1. Converte para minúsculas
        .normalize('NFD') // 2. Separa letra base dos acentos (ex: "á" -> "a" + "´")
        .replace(/[\u0300-\u036f]/g, ''); // 3. Remove os acentos (diacríticos)
}

function compareTexts(text1, text2) {
    if (!text1 || !text2) return false; // Retorna false se algum texto for nulo ou indefinido
    const normalizedText1 = normalizeText(text1);
    const normalizedText2 = normalizeText(text2);

    return normalizedText1.includes(normalizedText2);
}


export {
    isIe,
    isOpera,
    isFirefox,
    isSafari,
    isAndroid,
    isChrome,
    isEdge,
    isIntersectionObserver,
    isIOS,
    isMobile,
    isDesktop,
    isPushManager,
    isServiceWorker,
    isWindows,
    isEmpty,
    formatPhone,
    formatDocument,
    formatPostalCode,
    formatDate,
    formatMoney,
    formatNumber,
    moneyToFloat,
    downloadPdf,
    downloadCsv,
    downloadFile,
    isCpf,
    isIndexedDB,
    isVibrate,
    isString,
    isArray,
    isRegExp,
    isFunc,
    isProdEnv,
    isDevEnv,
    canShare,
    canShareLinks,
    vibrate,
    object2Params,
    replaceTags,
    DefaultRegExps,
    highlightText,
    reqAnimationFrame,
    makeRandomId,
    validateEmail,
    calcPage,
    humanizeNumber,
    pSBC,
    COLOR_RANGE,
    randomRGB,
    fillRandomRGB,
    normalizeText,
    compareTexts
}
